import { EntityPropList } from '@/common/entities/entityProp/EntityPropList';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntityDetail } from '../../../common/entityFramework/entityDetail/EntityDetail';
import { useNavState } from '../../../common/navState/NavStateContext';
import { Ndc9ProdList } from '../ndc9Prod/Ndc9ProdList';
import { LabelerForm } from './LabelerForm';

export const LabelerDetail = () => {

  const { navState } = useNavState();
  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <LabelerForm /> },
    { id: 'ndc9Tab', label: 'NDC9s', content: <Ndc9ProdList labelerId={navState.entityId} /> },
    { id: 'prop', label: 'Properties', content: <EntityPropList parentEntity="LABELER" parentEntityObj={entityObj} /> }
  ]

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}